import React, { useState } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Text,
  Image,
  TextInput,
  TouchableOpacity,
  StyleSheet,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppFonts from "../../Constants/AppFonts";
import AppImages from "../../Constants/AppImages";
import useAppNavigation from "../../Routes/useAppNavigation";

/**
 * PersonForm - reusable Add/Edit form for personnel (Driver, Fleet Manager,
 * Transport Manager, Vehicle Assistant, Delivery Person ...). Mirrors the
 * production add/edit pages. `fields` is an array of
 * { label, placeholder, secure, multiline }.
 */
const Row = ({ field }) => {
  const [v, setV] = useState("");
  return (
    <View style={styles.inputWrap}>
      <Text style={styles.label}>{field.label}</Text>
      <TextInput
        value={v}
        onChangeText={setV}
        placeholder={field.placeholder || field.label}
        placeholderTextColor="#ACACAC"
        secureTextEntry={field.secure}
        multiline={field.multiline}
        style={[styles.input, field.multiline && { height: 76, textAlignVertical: "top" }]}
      />
    </View>
  );
};

const PersonForm = ({ title = "Add", fields = [], submitLabel = "Save" }) => {
  const navigation = useAppNavigation();
  return (
    <SafeAreaView style={styles.safe}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={AppImages.Backbtn} style={styles.backIcon} resizeMode="contain" />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{title}</Text>
      </View>
      <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ padding: 20 }}>
        {fields.map((f, i) => (
          <Row key={i} field={f} />
        ))}
        <View style={styles.actions}>
          <TouchableOpacity style={styles.cancelBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.saveBtn} onPress={() => navigation.goBack()}>
            <Text style={styles.saveText}>{submitLabel}</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default PersonForm;

// Common base fields shared by all personnel add/edit forms.
export const baseFields = [
  { label: "First Name", placeholder: "Enter Your First Name" },
  { label: "Last Name", placeholder: "Enter Your Last Name" },
  { label: "Email", placeholder: "Enter Your Email" },
  { label: "Contact Number", placeholder: "Enter Your Contact Number" },
  { label: "Internal Number", placeholder: "Enter Your Internal Number" },
  { label: "Date Of Birth", placeholder: "DD-MM-YYYY" },
  { label: "Joining Date", placeholder: "DD-MM-YYYY" },
  { label: "Gender", placeholder: "Select Gender" },
  { label: "Nationality", placeholder: "Select Nationality" },
  { label: "City", placeholder: "Enter City" },
  { label: "Address", placeholder: "Enter Address", multiline: true },
];

export const passwordFields = [
  { label: "User Password", placeholder: "Enter Your Password", secure: true },
  { label: "Confirm Password", placeholder: "Re-enter Your Password", secure: true },
];

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: AppColors.white },
  header: {
    width: "100%",
    height: 58,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 20,
    backgroundColor: AppColors.white,
    shadowColor: "#9C4900",
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 1,
    shadowRadius: 10,
    elevation: 6,
  },
  backIcon: { width: 8, height: 15 },
  headerTitle: {
    color: AppColors.brown1,
    fontSize: 16,
    fontFamily: AppFonts.OverpassMedium,
    marginLeft: 20,
  },
  inputWrap: { marginBottom: 16 },
  label: {
    color: AppColors.brown1,
    fontSize: 13,
    fontFamily: AppFonts.OverpassMedium,
    marginBottom: 6,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ACACAC",
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 10,
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  actions: { flexDirection: "row", marginTop: 10, marginBottom: 30 },
  cancelBtn: {
    flex: 1,
    borderWidth: 1,
    borderColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginRight: 8,
  },
  cancelText: { color: AppColors.brown1, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
  saveBtn: {
    flex: 1,
    backgroundColor: AppColors.brown1,
    borderRadius: 10,
    paddingVertical: 12,
    alignItems: "center",
    marginLeft: 8,
  },
  saveText: { color: AppColors.white, fontSize: 15, fontFamily: AppFonts.OverpassMedium },
});
